module.exports = __webpack_public_path__ + "./img/choices-combinations-icon.svg";